export const STYLE_CLASSES = {
    expandAction: 'expand-action',
    action: 'action',
    titleGeneral: 'title-general',
    title: 'title',
    titleFli: 'title-fli',
    titleSubtotal: 'title-subtotal',
    titleAccountName: 'title-account-name',
    titleAccountNumber: 'title-account-number',
    closingCurrent: 'closing-current',
    closingReclass: 'closing-reclass',
    closingAdjustment: 'closing-adjustment',
    closingInternal: 'closing-internal',
    openingCurrent: 'opening-current',
    openingReclass: 'opening-reclass',
    openingAdjustment: 'opening-adjustment',
    openingInternal: 'opening-internal',
    changeInAdjustment: 'change-in-adjustment',
    incomeAccount: 'income-account',
} as const;
